<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="household_number"
                                    >Household Number</label
                                >
                                <input
                                    v-model="search_data.household_number"
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder="Search by HH No"
                                    id="household_number"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="village_id">Village</label>
                                <select
                                    v-model="search_data.village_id"
                                    class="form-control form-control-sm"
                                    name="village_id"
                                    id="village_id"
                                >
                                    <option selected :value="''">Select a village</option>
                                    <option v-for="(village, index) in villages" :key="index" :value="village.id"
                                        >{{ village.id }} : {{ village.village_desc }}</option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                                <select
                                    v-model="search_data.mouza_id"
                                    class="form-control form-control-sm"
                                    name="mouza_id"
                                    id="mouza_id"
                                >
                                    <option selected :value="''">Select a Mouza</option>
                                    <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id"
                                        >{{ mouza.id }} : {{ mouza.mouza_desc }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <div class="form-row mt-1">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="union_id ">Union</label>
                                <select
                                    v-model="search_data.union_id"
                                    class="form-control form-control-sm"
                                    name="union_id "
                                    id="union_id "
                                >
                                    <option selected :value="''">Select a Union</option>
                                    <option v-for="(union, index) in unions" :key="index" :value="union.id"
                                        >{{ union.id }} : {{ union.union_desc }}</option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="district_id">District</label>
                                <select
                                    v-model="search_data.district_id"
                                    class="form-control form-control-sm"
                                    name="district_id"
                                    id="district_id"
                                >
                                    <option selected :value="''">Select a District</option>
                                    <option v-for="(district, index) in districts" :key="index" :value="district.id"
                                        >{{ district.id }} : {{ district.district_desc }}</option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="division_id">Division</label>
                                <select
                                    v-model="search_data.division_id"
                                    class="form-control form-control-sm"
                                    name="division_id"
                                    id="division_id"
                                >
                                    <option selected :value="''">Select a Division</option>
                                    <option v-for="(division, index) in divisions" :key="index" :value="division.id"
                                        >{{ division.id }} : {{ division.division_desc }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search()">Search</button>
                    </form>
                </b-card>

                <b-card>
                    <!--                    <button v-if="ses_eps.length > 0 || ses_power_group_ids.length > 0" class="float" @click.prevent="prepareEstimate">Prepare Estimates</button>-->
                    <router-link
                        target="_blank"
                        v-if="ses_eps.length > 0 || ses_power_group_ids.length > 0"
                        class="btn float"
                        :to="{
                            name: 'estimateNonTitleCreate',
                            query: { ses_eps: this.ses_eps, ses_power_group_ids: this.ses_power_group_ids },
                            target: '_blank',
                        }"
                    >
                        Prepare Estimates
                    </router-link>
                    <div class="row mb-2" v-if="seses.total > 0">
                        <div class="col-sm-4">
                            <span class="badge badge-success">Total Search Data Found: {{ seses.total }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Individually / Group</th>
                                    <th>EP ID</th>
                                    <th>Name</th>
                                    <th>Father Name</th>
                                    <th>Mobile</th>
                                    <th>Village</th>
                                    <th>Mouza</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ses, index) in seses.data" :key="index">
                                    <td>
                                        <input type="checkbox" :value="ses.ep_id.id" v-model="ses_eps" />
                                        <span v-if="ses.ses_power_groups.length > 0">
                                            /
                                            <span v-for="(ses_power_group, index) in ses.ses_power_groups" :key="index">
                                                <input
                                                    type="checkbox"
                                                    :value="ses_power_group.id"
                                                    v-model="ses_power_group_ids"
                                                />(Gp {{ ses_power_group.id }})
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        {{ epIdWithPaymentStatus(ses.ep_id.ep_id, ses.ep_id.is_paid) }}
                                    </td>
                                    <td>
                                        <router-link
                                            :to="{ name: 'sesView', params: { ses_id: ses.id } }"
                                            tag="a"
                                            target="_blank"
                                            >{{ ses.name }}</router-link
                                        >
                                    </td>
                                    <td>{{ ses.father_husband_name }}</td>
                                    <td>{{ ses.mobile }}</td>
                                    <td>{{ ses.village.village_desc }}</td>
                                    <td>{{ ses.mouza.mouza_desc }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h5 v-if="!flag || seses.total == 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                        <div class="float-right">
                            <pagination :data="seses" :limit="2" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
    page: {
        title: 'List SES',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: 'Search SES',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'SES',
                    active: true,
                },
            ],
            seses: {},
            search_data: {
                household_number: '',
                village_id: '',
                mouza_id: '',
                union_id: '',
                district_id: '',
                division_id: '',
            },
            villages: [],
            mouzas: [],
            unions: [],
            districts: [],
            divisions: [],
            isCheckAll: false,
            ses_eps: [],
            ses_power_group_ids: [],
            flag: false,
        }
    },

    mounted() {
        this.search_data.ep_type = this.$route.params.ep_type
        this.search_data.district_id = this.$route.params.district_id
        this.getCodes()
    },
    methods: {
        epIdWithPaymentStatus: epIdWithPaymentStatus,
        getCodes() {
            http.get('api/estimate/codes').then((response) => {
                if (!response.error) {
                    let data = response.data
                    this.villages = data.villages
                    this.mouzas = data.mouzas
                    this.unions = data.unions
                    this.districts = data.districts
                    this.divisions = data.divisions
                }
            })
        },
        search() {
            http.post('api/estimate/search', this.search_data).then((response) => {
                if (!response.error) {
                    this.flag = true
                    this.seses = response.data.seses
                }
            })
        },
        getResults(page = 1) {
            http.post('api/estimate/search?page=' + page, this.search_data).then((response) => {
                this.flag = true
                this.seses = response.data.seses
            })
        },
        prepareEstimate() {
            http.post('api/estimate/non-title/create', {
                ses_eps: this.ses_eps,
                ses_power_group_ids: this.ses_power_group_ids,
            }).then((response) => {
                if (!response.error) {
                    this.$router.push({
                        name: 'estimateNonTitleCreate',
                        query: { prepare_estimates: response.data.prepare_estimates },
                    })
                }
            })
        },
    },
}
</script>
<style lang="scss">
.float {
    position: fixed;
    width: 150px;
    height: 38px;
    bottom: 65px;
    /*right:40px;*/
    left: 40px;
    background-color: #0c9;
    color: #fff;
    /*border-radius:50px;*/
    text-align: center;
    box-shadow: 2px 2px 3px #999;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}
</style>
